/* ============================================================
   ROXANA — interacciones
   Vanilla, sin librerias. Cada init es idempotente (guard por
   elemento) para sobrevivir a los re-render del editor de Shopify.
   ============================================================ */
(function () {
  'use strict';

  // Guard de ejecucion unica: la misma etiqueta <script src> aparece en
  // varias secciones y el navegador ejecuta cada una.
  if (window.__rxInit) return;
  window.__rxInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function claim(el, key) {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Reveals compartidos ---------- */
  var revealObserver = null;
  function initReveals() {
    var nodes = document.querySelectorAll('.rx-reveal:not([data-rxReveal]), .rx-observe:not([data-rxReveal])');
    if (!nodes.length) return;

    if (reduced) {
      nodes.forEach(function (n) {
        n.dataset.rxReveal = '1';
        n.classList.add('rx-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('rx-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
      );
    }

    nodes.forEach(function (n) {
      n.dataset.rxReveal = '1';
      revealObserver.observe(n);
    });
  }

  /* ---------- 1. Hero spotlight (arquetipo 9) ---------- */
  function initHero() {
    document.querySelectorAll('.rx-hero').forEach(function (hero) {
      if (!claim(hero, 'rxHero')) return;
      var spot = hero.querySelector('.rx-hero__spot');
      if (!spot || reduced) return;
      if (window.matchMedia('(hover: none)').matches) return;

      var raf = null;
      var pending = null;

      function apply() {
        raf = null;
        if (!pending) return;
        spot.style.setProperty('--rx-mx', pending.x + '%');
        spot.style.setProperty('--rx-my', pending.y + '%');
      }

      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        pending = {
          x: (((e.clientX - r.left) / r.width) * 100).toFixed(2),
          y: (((e.clientY - r.top) / r.height) * 100).toFixed(2)
        };
        if (!raf) raf = requestAnimationFrame(apply);
      });

      hero.addEventListener('pointerleave', function () {
        spot.style.removeProperty('--rx-mx');
        spot.style.removeProperty('--rx-my');
      });
    });
  }

  /* ---------- 3. Macro zoom ligado al scroll (arquetipo 28) ---------- */
  var macroTargets = [];
  var macroTicking = false;

  function macroUpdate() {
    macroTicking = false;
    macroTargets.forEach(function (t) {
      var r = t.stage.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) return;
      var p = Math.min(Math.max(-r.top / total, 0), 1);
      var scale = t.from + (t.to - t.from) * p;
      t.img.style.setProperty('--rx-macro-scale', scale.toFixed(4));
    });
  }

  function onMacroScroll() {
    if (macroTicking) return;
    macroTicking = true;
    requestAnimationFrame(macroUpdate);
  }

  function initMacro() {
    document.querySelectorAll('.rx-macro__stage').forEach(function (stage) {
      if (!claim(stage, 'rxMacro')) return;
      var img = stage.querySelector('.rx-macro__img');
      if (!img) return;
      if (reduced) {
        img.style.setProperty('--rx-macro-scale', '1.15');
        return;
      }
      macroTargets.push({
        stage: stage,
        img: img,
        from: parseFloat(stage.dataset.zoomFrom || '1'),
        to: parseFloat(stage.dataset.zoomTo || '1.6')
      });
      if (macroTargets.length === 1) {
        window.addEventListener('scroll', onMacroScroll, { passive: true });
        window.addEventListener('resize', onMacroScroll, { passive: true });
      }
      onMacroScroll();
    });
  }

  /* ---------- 6. Parallax del collage (arquetipo 72) ---------- */
  var parallaxItems = [];
  var parallaxTicking = false;

  function parallaxUpdate() {
    parallaxTicking = false;
    var vh = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var r = item.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var centre = r.top + r.height / 2;
      var offset = ((centre - vh / 2) / vh) * item.depth * -1;
      item.el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) rotate(' + item.rot + 'deg)';
    });
  }

  function onParallaxScroll() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    requestAnimationFrame(parallaxUpdate);
  }

  function initParallax() {
    if (reduced || window.innerWidth < 990) return;
    document.querySelectorAll('.rx-collage__ph').forEach(function (el) {
      if (!claim(el, 'rxParallax')) return;
      parallaxItems.push({
        el: el,
        depth: parseFloat(el.dataset.depth || '20'),
        rot: parseFloat(el.dataset.rot || '0')
      });
      if (parallaxItems.length === 1) {
        window.addEventListener('scroll', onParallaxScroll, { passive: true });
        window.addEventListener('resize', onParallaxScroll, { passive: true });
      }
      onParallaxScroll();
    });
  }

  /* ---------- 7. FAQ (arquetipo 80) ---------- */
  function initFaq() {
    document.querySelectorAll('.rx-faq__list').forEach(function (list) {
      if (!claim(list, 'rxFaq')) return;
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.rx-faq__q');
        if (!btn || !list.contains(btn)) return;
        var item = btn.closest('.rx-faq__item');
        var open = item.dataset.open === 'true';
        if (list.dataset.single === 'true') {
          list.querySelectorAll('.rx-faq__item').forEach(function (other) {
            other.dataset.open = 'false';
            var q = other.querySelector('.rx-faq__q');
            if (q) q.setAttribute('aria-expanded', 'false');
          });
        }
        item.dataset.open = open ? 'false' : 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- 8. CTA magnetico (arquetipo 88) ---------- */
  function initMagnetic() {
    if (reduced || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.rx-btn--magnetic').forEach(function (btn) {
      if (!claim(btn, 'rxMagnetic')) return;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        btn.style.transform = 'translate(' + (dx * 5).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ---------- Galeria de la pagina de producto ---------- */
  function initPdpGallery() {
    document.querySelectorAll('.rx-pdp__gallery').forEach(function (gallery) {
      if (!claim(gallery, 'rxGallery')) return;
      var main = gallery.querySelector('.rx-pdp__main img');
      if (!main) return;
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('.rx-pdp__thumb');
        if (!thumb || !gallery.contains(thumb)) return;
        var src = thumb.dataset.full;
        if (src) main.src = src;
        gallery.querySelectorAll('.rx-pdp__thumb').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Arranque ---------- */
  function initAll() {
    initReveals();
    initHero();
    initMacro();
    initParallax();
    initFaq();
    initMagnetic();
    initPdpGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor de Shopify re-renderiza secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', initAll);
})();
